module.exports = __webpack_public_path__ + "static/media/youtube.ce61a0ce.svg";